/**
 * Helper function to get a property from an object, checking both lowercase and uppercase versions
 * @param {Object} obj - The object to get the property from
 * @param {string} propName - The property name to look for
 * @returns {*} The property value, or undefined if not found
 */
export const getProperty = (obj, propName) => {
  if (!obj || typeof obj !== 'object') {
    return undefined;
  }
  
  // Try uppercase first (common convention)
  const upperProp = propName.charAt(0).toUpperCase() + propName.slice(1);
  const lowerProp = propName.charAt(0).toLowerCase() + propName.slice(1);
  
  // Check both cases
  if (obj[upperProp] !== undefined) {
    return obj[upperProp];
  }
  if (obj[lowerProp] !== undefined) {
    return obj[lowerProp];
  }
  
  // Also check exact match
  if (obj[propName] !== undefined) {
    return obj[propName];
  }
  
  return undefined;
};

/**
 * Helper function to get a nested property from an object
 * @param {Object} obj - The object to get the property from
 * @param {string} path - The property path (e.g., "studentUserDTO.MentorId")
 * @returns {*} The property value, or undefined if not found
 */
export const getNestedProperty = (obj, path) => {
  if (!obj || typeof obj !== 'object') {
    return undefined;
  }
  
  const parts = path.split('.');
  let current = obj;
  
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    const value = getProperty(current, part);
    
    if (value === undefined) {
      return undefined;
    }
    
    if (i === parts.length - 1) {
      return value;
    }
    
    current = value;
    if (typeof current !== 'object' || current === null) {
      return undefined;
    }
  }
  
  return undefined;
};
